import { render, staticRenderFns } from "./Vendorrejectlist.vue?vue&type=template&id=4581be22"
import script from "./Vendorrejectlist.vue?vue&type=script&lang=js"
export * from "./Vendorrejectlist.vue?vue&type=script&lang=js"
import style0 from "./Vendorrejectlist.vue?vue&type=style&index=0&id=4581be22&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports